/**
 * Rotating subtasks in lists (ADR 0035): a task shows as "Task: Subtask", the part of this round that is the viewer's,
 * else the round's open parts.
 */
import { readRounds } from "../core/ops";
import { useDocSelector } from "../core/useDocSelector";
import type { DocHandle } from "../sync/docManager";
import type { Part } from "../core/parts";

export type Rounds = ReturnType<typeof readRounds>;

export function useRounds(handle: DocHandle | null): Rounds {
  return useDocSelector(handle, (doc) => readRounds(doc)) ?? {};
}

/** The parts a row shows: the viewer's open part, else every open part. */
export function shownParts(rounds: Rounds, taskId: string, me: string | null): Part[] {
  const r = rounds[taskId];
  if (!r) return [];
  const open = r.round.parts.filter((p) => !p.done);
  const mine = open.find((p) => p.who !== null && p.who === me);
  return mine ? [mine] : open;
}

/** "Clean the bathroom: Sink", or the plain title for a task without rotating subtasks. */
export function partTitle(
  t: (key: string, opts?: Record<string, string>) => string,
  rounds: Rounds,
  task: { id: string; title: string },
  me: string | null,
): string {
  const parts = shownParts(rounds, task.id, me);
  if (!parts.length) return task.title;
  const titles = rounds[task.id].titles;
  return t("parts.title", { task: task.title, sub: parts.map((p) => titles[p.sub]).join(", ") });
}
